import getServiceVersionless from './getServiceVersionless';

// OBI = Order Billing Item (zenapi subscription line item)
const OBI_STATUS_MESSAGES = {
  pending: (fm) => fm({ id: 'dashboard.subscriptions.status.pending' }),
  active: (fm, { endDate }) => fm({ id: 'dashboard.subscriptions.status.active' }, { endDate }),
  activePending: (fm) => fm({ id: 'dashboard.subscriptions.status.activePending' }),
  cancelRenewalPending: (fm) => fm({ id: 'dashboard.subscriptions.status.cancelRenewalPending' }),
  cancelRenewal: (fm, { endDate }) => fm({ id: 'dashboard.subscriptions.status.cancelRenewal' }, { endDate }),
  canceled: (fm, { endDate }) => fm({ id: 'dashboard.subscriptions.status.canceled' }, { endDate }),
  paymentFailed: (fm) => fm({ id: 'dashboard.subscriptions.status.paymentFailed' }),
  inTrial: (fm, { startDate }) => fm({ id: 'dashboard.subscriptions.status.inTrial' }, { startDate }),
  trialRenews: (fm, { price, period, endDate }) =>
    fm({ id: 'dashboard.subscriptions.status.trialRenews' }, { price, period, endDate }),
};

export const OBI_STATUS_MAP = new Map([
  ['new', (fm) => OBI_STATUS_MESSAGES.pending(fm)],
  ['created', (fm) => OBI_STATUS_MESSAGES.pending(fm)],
  ['deferred', (fm) => OBI_STATUS_MESSAGES.pending(fm)],
  ['active', (fm, { endDate }) => OBI_STATUS_MESSAGES.active(fm, { endDate })],
  ['active_pending', (fm) => OBI_STATUS_MESSAGES.activePending(fm)],
  ['paid', (fm, { endDate }) => OBI_STATUS_MESSAGES.active(fm, { endDate })],
  ['cancel_renewal_pending', (fm) => OBI_STATUS_MESSAGES.cancelRenewalPending(fm)],
  ['cancel_renewal', (fm, { endDate }) => OBI_STATUS_MESSAGES.cancelRenewal(fm, { endDate })],
  ['canceled', (fm, { endDate }) => OBI_STATUS_MESSAGES.canceled(fm, { endDate })],
  ['payment_failed', (fm) => OBI_STATUS_MESSAGES.paymentFailed(fm)],
  ['in_trial', (fm, { startDate }) => OBI_STATUS_MESSAGES.inTrial(fm, { startDate })],
  ['trial_renews', (fm, { price, period, endDate }) => OBI_STATUS_MESSAGES.trialRenews(fm, { price, period, endDate })],
]);

const TRIAL_ELIGIBLE_SERVICES = ['website_tools_bundle', 'zb_website_tools_bundle', 'zb_money_pro'];

export default function translateSubscriptionStatus({
  formatMessage,
  status,
  paymentStatus,
  termEndDate,
  cancelDate,
  inTrial,
  termStartDate,
  service,
  price,
  period,
}) {
  const fm = formatMessage;
  const periodLabel =
    period === 'monthly'
      ? fm({ id: 'dashboard.subscriptions.status.periodMonth' })
      : fm({ id: 'dashboard.subscriptions.status.periodYear' });

  let message;
  const serviceVersionless = getServiceVersionless(service);
  const isTrialEligible = TRIAL_ELIGIBLE_SERVICES.includes(serviceVersionless);

  if (inTrial) {
    if (isTrialEligible) {
      if (['cancel_renewal', 'cancel_renewal_pending'].includes(status)) {
        message = OBI_STATUS_MAP.get(status);
      } else {
        message = !price ? OBI_STATUS_MAP.get('cancel_renewal') : OBI_STATUS_MAP.get('trial_renews');
      }
    } else {
      message = OBI_STATUS_MAP.get('in_trial');
    }
  } else if (paymentStatus === 'failed' && !['cancel_renewal', 'cancel_renewal_pending', 'canceled'].includes(status)) {
    message = OBI_STATUS_MAP.get('payment_failed');
  } else {
    message = OBI_STATUS_MAP.get(status);
  }

  if (!message) {
    return OBI_STATUS_MAP.get('active')(fm, { endDate: termEndDate });
  }

  const useTrialEndDate = inTrial && isTrialEligible && termStartDate;
  // These paid statuses should show the current term boundary when billing provides it.
  const useTermEndDate = ['active', 'paid', 'cancel_renewal', 'cancel_renewal_pending'].includes(status);
  let endDate = cancelDate || termEndDate;
  if (useTrialEndDate) {
    endDate = termStartDate;
  } else if (useTermEndDate) {
    endDate = termEndDate || cancelDate;
  }

  return message(fm, {
    endDate,
    startDate: termStartDate,
    price,
    period: periodLabel,
  });
}
